var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sales-shadow mb-2" }, [
    _c(
      "div",
      {
        staticClass: "sales-box p-2",
        on: {
          click: function($event) {
            $event.stopPropagation()
            $event.preventDefault()
            _vm.$emit("openSidebar")
          }
        }
      },
      [
        _c("div", { staticClass: "row w-100 mx-1" }, [
          _c("div", { staticClass: "sales-info-wrapper col-3 p-0" }, [
            _c("a", { attrs: { href: "#" } }, [
              _c(
                "div",
                {
                  staticClass: "sale-ref-id pointer",
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.goToUser($event)
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.sale.ref_id))]
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sale-info" }, [
              _vm._v("\n          " + _vm._s(_vm.sale.date) + "\n        ")
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-info-wrapper col-3 p-0" }, [
            _c("div", { staticClass: "sale-info-numbers" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.sale.carrier_sale) + "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-info-wrapper col-3 p-0" }, [
            _c("div", { staticClass: "sale-info-numbers pl-2" }, [
              _vm._v(
                "\n          " + _vm._s(_vm.sale.cluster_sale) + "\n        "
              )
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "sales-info-wrapper col-3 p-0" }, [
            _c(
              "div",
              { staticClass: "sale-info-numbers justify-content-end pr-2" },
              [_vm._v("\n          " + _vm._s(_vm.sale.balance) + "\n        ")]
            ),
            _vm._v(" "),
            _vm.sale.payment_status_id === 3
              ? _c(
                  "span",
                  { staticClass: "ml-2 sale-status-paid text-center" },
                  [_vm._v("\n          paid\n        ")]
                )
              : _vm._e()
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _vm.expanded
      ? _c(
          "div",
          {
            staticClass: "sales-box p-2",
            on: {
              click: function($event) {
                $event.stopPropagation()
                $event.preventDefault()
                _vm.$emit("openSidebar")
              }
            }
          },
          [
            _c("div", { staticClass: "border-top-expanded row mx-1 w-100" }, [
              _c("div", { staticClass: "col-12 row mt-2 pr-0" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Time")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " + _vm._s(_vm.sale.time) + "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Tips")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.sale.card_tips) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Fee")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.sale.mod_tier_id
                            ? _vm.sale.mod_tier_percentage + "%"
                            : _vm.sale.percent + "% (" + _vm.sale.fee + ")"
                        ) +
                        "\n          "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-12 row mt-2 pr-0" }, [
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Deposit")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.sale.deposit) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Cash")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.sale.cash_payment) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Credit")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.sale.sale_credit) +
                        "\n          "
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-3" }, [
                  _c("label", { staticClass: "expanded-label" }, [
                    _vm._v("Grand sale")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "expanded-col-data" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.sale.sale_price) +
                        "\n          "
                    )
                  ])
                ])
              ])
            ])
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6b2f63d2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6b2f63d2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/sales/SalesTotalsBlockMobile.vue
// module id = null
// module chunks = 